import React, { Component } from 'react';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import { Link } from 'react-router-dom';
import './Dojo.css';
import { DojoRepository } from '../data/DojoRepository';

class StAdolphe extends Component {
  render() {
    return (
        <div class="container page-content">
            <div id="dojoHeader">
                <img id="ShotokanLogo" alt="Logo du karaté Shotokan" src="/images/logos/Shotokan.png" />
            </div>
            <article id="dojoContent">
                <section id="dojoDescription"> 
                    <h1>{DojoRepository.ST_ADOLPHE.name}</h1>
                    <p>Le dojo Niju Kun St-Adolphe d’Howard existe depuis 2006. Situé au cœur des Laurentides, dans un petit village où il fait bon vivre, les parents pratiquent leur sport en même temps que leurs enfants. Ils apprécient pouvoir faire une activité ensemble. Nous accueillons des gens de tous les âges et chacun progresse à son propre rythme.</p>
                    <p>Notre philosophie est de permettre à nos élèves de se dépasser et de s’épanouir à travers la pratique de cet art martial.</p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoTeam"> 
                    <h1>L'équipe</h1>
                        <p><strong>Instructeurs</strong></p>
                        <div>
                            {DojoRepository.ST_ADOLPHE.contact.sylvain.fullName} - {DojoRepository.ST_ADOLPHE.contact.sylvain.rank}<br />
                            {DojoRepository.ST_ADOLPHE.contact.suzanne.fullName} - {DojoRepository.ST_ADOLPHE.contact.suzanne.rank}
                        </div>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoSchedule"> 
                    <h1>Horaire</h1>
                        <p><strong>Mercredi</strong></p>
                        <p>18:15 - Cours pour tous</p>
                        <p><strong>Samedi</strong></p>
                        <p>10:00 - Cours pour tous</p>
                </section>
                <p>&nbsp;</p>

                <section id="dojoPrices"> 
                    <h1>Tarifs</h1>
                    <table border="1" class="price-table"  cellSpacing="1" cellPadding="1">
                        <tbody>
                            <tr>
                                <td colSpan="2">Tarif pour une sesion (Enfants/Adultes)</td>
                            </tr>
                            <tr>
                                <td class="description-column" >Résidents de St-Adolphe</td>
                                <td class="price-column" >135$</td>
                            </tr>
                            <tr>
                                <td class="description-column" >Non résidents</td>
                                <td class="price-column" >145$</td>
                            </tr>
                        </tbody>
                    </table>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoContacts"> 
                    <h1>Pour nous joindre</h1>
                    <p>
                        <strong>{DojoRepository.ST_ADOLPHE.name}</strong><br />
                        {DojoRepository.ST_ADOLPHE.address.line1}<br />
                        {DojoRepository.ST_ADOLPHE.address.city}<br />
                        {DojoRepository.ST_ADOLPHE.address.postalCode}<br />
                        <a href={DojoRepository.ST_ADOLPHE.links.googleMaps} target="_blank" rel="noopener noreferrer" title={DojoRepository.ST_ADOLPHE.name}>Google Maps</a>
                    </p>
                    <p>
                        <strong>{DojoRepository.ST_ADOLPHE.contact.sylvain.fullName}</strong><br />
                        {DojoRepository.ST_ADOLPHE.contact.sylvain.phone1}<br />
                        <span class="link-like">{DojoRepository.ST_ADOLPHE.contact.sylvain.email1}</span><br />
                    </p>
                    <p>
                        <strong>{DojoRepository.ST_ADOLPHE.contact.suzanne.fullName}</strong><br />
                        {DojoRepository.ST_ADOLPHE.contact.suzanne.phone1}<br />
                        <span class="link-like">{DojoRepository.ST_ADOLPHE.contact.suzanne.email1}</span><br />
                    </p>
                </section> 
                <p>&nbsp;</p>
                
                <section id="dojo-map">
                    <Map
                        google={this.props.google}
                        initialCenter={DojoRepository.ST_ADOLPHE.geo}>
                        <Marker position={DojoRepository.ST_ADOLPHE.geo} />
                    </Map>
                </section> 
            </article>
            <Link class="returnToDojoRepository" to="/dojo">Retour au repertoire des Dojos</Link>
        </div>
    );
  }
}

export default GoogleApiWrapper({
    apiKey: ("AIzaSyCqdJMLfuasXIr2gfxOzJyfP1gXVQt5-H8")
})(StAdolphe);



// WEBPACK FOOTER //
// ./src/pages/dojo/StAdolphe.js